// extracted by css-extract-rspack-plugin
export default {"container":"IssuePreview-module__container__xS1d_"};